/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import { number, oneOfType, string } from 'prop-types';
import classNames from 'classnames';
import { Button } from '@thd-olt-component-react/button';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import './Voting.styles.scss';
import VotingHelper from './helper/VotingHelper';

class Voting extends Component {
  static CookieUtils;

  constructor(props) {
    super(props);
    this.ref = React.createRef();
    const { totalPositiveFeedbackCount, totalNegativeFeedbackCount } = props;
    this.state = {
      liked: false,
      noOfLikes: totalPositiveFeedbackCount,
      disliked: false,
      noOfDislikes: totalNegativeFeedbackCount,
      reported: false,
      userId: '',
      tooltipOpen: false
    };
  }

  async componentDidMount() {
    const { default: cookieUtils } = await import('cookie-utils');
    Voting.CookieUtils = cookieUtils;
    this.setUserId();
  }

  setUserId = () => {
    const thdUserId = Voting.CookieUtils.readBrowserCookie('THD_USER_ID');
    this.setState({ userId: thdUserId });
  };

  changeTooltipVisible = () => {
    this.setState(({ tooltipOpen }) => ({ tooltipOpen: !tooltipOpen }));
  };

  validateComment = () => {
    const { formText } = this.state;
    if (formText.length === 0) {
      this.setState({ disableSubmit: true });
    }
  };

  handleInputChange = (event) => {
    const formText = event.target.value;
    this.setState({ formText });
  };

  submitReport = (event) => {
    event.preventDefault();
    const { apiKey, hostName, reviewId } = this.props;
    const { formText } = this.state;
    VotingHelper.notifyBV(hostName, reviewId, 'inappropriate', '', formText, apiKey);
    this.setState({
      reported: true
    });
    this.changeTooltipVisible();
  };

  toggleLikeEvent = (event, type) => {
    event.preventDefault();
    const voteType = type === 'disliked' ? 'Negative' : 'Positive';
    const changeType = this.state[type] ? 'UNDO' : voteType;
    const { totalPositiveFeedbackCount, totalNegativeFeedbackCount } = this.props;

    this.setState((currentState) => {
      const noOfDislikes = type === 'disliked' && !currentState.disliked
        ? totalNegativeFeedbackCount + 1
        : totalNegativeFeedbackCount;
      const noOfLikes = type === 'liked' && !currentState.liked
        ? totalPositiveFeedbackCount + 1
        : totalPositiveFeedbackCount;
      const liked = type === 'liked' ? !currentState.liked : currentState.liked;
      const disliked = type === 'disliked' ? !currentState.disliked : currentState.disliked;
      return {
        liked,
        disliked,
        noOfDislikes,
        noOfLikes
      };
    });

    const { apiKey, hostName, reviewId } = this.props;
    VotingHelper.notifyBV(hostName, reviewId, 'helpfulness', changeType, '', apiKey, this.state.userId);
  };

  handleOnHideTooltip = () => {
    if (this.state.tooltipOpen) {
      this.changeTooltipVisible();
    }
  };

  render() {
    const { reviewId } = this.props;
    const {
      disliked,
      formText,
      liked,
      noOfDislikes,
      noOfLikes,
      reported,
      tooltipOpen,
    } = this.state;
    const likeClass = classNames({
      ratings_reviews__voting__activeLike: liked,
      ratings_reviews__voting__passiveLike: !liked,
      nocursor: this.state.disliked
    });

    const dislikeClass = classNames({
      ratings_reviews__voting__activeDislike: disliked,
      ratings_reviews__voting__passiveDislike: !disliked,
      nocursor: liked
    });

    const reportClass = classNames({
      ratings_reviews__voting__activeReport: reported,
      ratings_reviews__voting__passiveReport: !reported
    });

    return (
      <div className="ratings_reviews__voting" id="voting">
        <Row>
          <Col xs="5" className="voting__helpful_message"><b>Was this helpful?</b></Col>
          <Col xs="2">
            <button
              className={likeClass}
              id="like"
              onClick={(e) => this.toggleLikeEvent(e, 'liked')}
              title="Helpful"
            />
            <span className="count">{noOfLikes}</span>
          </Col>
          <Col xs="2">
            <button
              className={dislikeClass}
              id="dislike"
              onClick={(e) => this.toggleLikeEvent(e, 'disliked')}
              title="Unhelpful"
            />
            <span className="count">{noOfDislikes}</span>
          </Col>
          <Col xs="2">
            <Tooltip
              channel="desktop"
              content={(
                <form onSubmit={this.submitReport} className="ratings_reviews__voting__toolTip__form">
                  <Row>
                    <label
                      className="ratings_reviews__voting__toolTip__textareaLabel"
                      htmlFor="ratings_reviews__voting__toolTip__textarea"
                    >
                      <span>Describe the issue</span>
                    </label>
                    <textarea
                      id="ratings_reviews__voting__toolTip__textarea"
                      className="ratings_reviews__voting__toolTip__textarea"
                      rows="10"
                      cols="10"
                      value={formText}
                      onChange={this.handleInputChange}
                    />
                  </Row>
                  <Row className="ratings_reviews__voting__toolTip__buttons">
                    <Col className="ratings_reviews__voting__toolTip__cancel" sm="4">
                      <Button
                        type="border"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          this.changeTooltipVisible();
                        }}
                      >
                        Cancel
                      </Button>
                    </Col>
                    <Col className="ratings_reviews__voting__toolTip__submit" sm="4">
                      <Button type="border" onClick={this.submitReport}>
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </form>
              )}
              interactive
              isVisible={tooltipOpen}
              onHide={this.handleOnHideTooltip}
            >
              <button
                className={reportClass}
                id={`reportIssue_${reviewId}`}
                onClick={this.changeTooltipVisible}
                title="Report"
              />
            </Tooltip>
          </Col>
        </Row>
      </div>
    );
  }
}

Voting.displayName = 'RatingsAndReviewsVoting';

Voting.propTypes = {
  hostName: string.isRequired,
  reviewId: oneOfType([string, number]).isRequired,
  totalPositiveFeedbackCount: number,
  totalNegativeFeedbackCount: number,
  apiKey: string.isRequired
};

Voting.defaultProps = {
  totalPositiveFeedbackCount: 0,
  totalNegativeFeedbackCount: 0
};

export { Voting };
